module.exports = __webpack_public_path__ + "static/media/adoveacrobat.0e6ec58c.svg";